export default function LoadingPlaceholder({
  height = 'auto'
}) {
  return <div style={{
    width: '100%',
    height: height
  }} data-sentry-component="LoadingPlaceholder" data-sentry-source-file="loading-placeholder.tsx" />;
}